import { render, staticRenderFns } from "./OrderProjectDialog.vue?vue&type=template&id=2387e0f8&scoped=true&"
import script from "./OrderProjectDialog.vue?vue&type=script&lang=js&"
export * from "./OrderProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderProjectDialog.vue?vue&type=style&index=0&id=2387e0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387e0f8",
  null
  
)

export default component.exports